import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: [],
    prices: {}
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    },
    changeItem (state, item) {
      const items = state.items.filter((i) => i.id !== item.id)
      state.items = [...items, item]
    },
    setPrice (state, { id, price }) {
      const newPrices = { ...state.prices }
      newPrices[id] = price
      state.prices = newPrices
    }
  },
  getters: {
    getItem: (state) => (id) => {
      const shearchId = parseInt(id)
      return state.items.find((i) => i.id === shearchId)
    }
  },
  actions: {
    getList ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.campaignsAdvertiser(token)
            .then((res) => {
              commit('setItems', res.body.list)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getOne ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getCampaignAdvertiser(token, campaignId)
            .then((res) => {
              commit('changeItem', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getPrice ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getCampaignAdvertiserPrice(token, campaignId)
            .then((res) => {
              commit('setPrice', { id: campaignId, price: res.body })
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    add ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.addCampaignsAdvertiser(token, data)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    edit ({ commit, state, dispatch }, { id, data }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editCampaignAdvertiser(token, id, data)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    delete ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.deleteCampaignAdvertiser(token, campaignId)
            .then((res) => {
              dispatch('getList')
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    cancel ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.cancelCampaignAdvertiser(token, campaignId)
            .then((res) => {
              dispatch('getList')
              dispatch('campaignsMembersAdvertiser/getMembers', campaignId, { root: true })
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    startInviting ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.startInviteCampaignAdvertiser(token, campaignId)
            .then((res) => {
              dispatch('getList')
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    startWithoutFullMembers ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.startWithoutFullMembersCampaignAdvertiser(token, campaignId)
            .then((res) => {
              dispatch('getList')
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
